import React, { Component } from "react";
import styled from "styled-components";
import logo from "./img/logohorizantal.jpg";
import logov from "./img/logovertical.jpg";
import { FaInstagram } from "react-icons/fa";
import { AiOutlineFacebook } from "react-icons/ai";
import { SiTiktok, SiVsco } from "react-icons/si";
import { FiTwitter } from "react-icons/fi";
import "./App.css";

const Main = styled.div`
  height: 100vh;
  background: linear-gradient(to bottom, transparent, transparent, white 98%),
    url(${logo});
  background-size: cover;

  @media (max-width: 500px) {
    width: 100%;

    background: linear-gradient(to bottom, transparent, transparent, white 98%),
      url(${logov});
    background-size: cover;
  }
/* .scroll{
    display: flex;
    height:70%;
    align-items:flex-end;
    justify-content:center
} */
`;
const Div = styled.div`
  display: flex;
  justify-content: space-evenly;
  height: 90%;
  align-items: flex-end;
  @media (max-width: 500px) {
    height: 95%;
  }
`;

export class Mujy extends Component {
  render() {
    return (
      <Main>
      
{/* 
        <div class="mouse_scroll">
          <div class="mouse">
            <div class="wheel"></div>
          </div>
          <div>
            <span class="m_scroll_arrows unu"></span>
            <span class="m_scroll_arrows doi"></span>
            <span class="m_scroll_arrows trei"></span>
          </div>
        </div> */}

        <Div>
          <a href="https://instagram.com/mujymix">
            <FaInstagram size="30px" />
          </a>
          <a href="https://instagram.com/mujymix">
            <AiOutlineFacebook size="30px" />
          </a>
          <a href="https://instagram.com/mujymix">
            <FiTwitter size="30px" />
          </a>
          <a href="https://instagram.com/mujymix">
            <SiVsco size="30px" />
          </a>
          <a href="https://instagram.com/mujymix">
            <SiTiktok size="30px" />
          </a>
        </Div>
      </Main>
    );
  }
}

export default Mujy;
